import type * as React from "react";
import { type SyntheticEvent, useMemo } from "react";

import {
  defaultRenderItem,
  type MUIPaginationProps,
  Pagination as DefaultPagination,
  PaginationItem,
} from "../../../common/components/Pagination/Pagination";
import { type PaginationRenderItemParams } from "@mui/material";

export interface PaginationProps {
  currentPage: number;
  pageAmount: number;
  onPageChange: (pageNum: number) => void;
  goToIdAfterChange?: string; // for example #results
  renderHrefs?: boolean; // IGNORED
  classes?: MUIPaginationProps["classes"];
}

export const Pagination = (props: PaginationProps) => {
  const onChange = (e: React.ChangeEvent<unknown>, page: number) => {
    if (props.goToIdAfterChange) {
      document.querySelector(props.goToIdAfterChange)?.scrollIntoView();
    } else {
      window.scrollTo?.(0, 0);
    }
    props.onPageChange(page - 1);
  };

  const renderItem = useMemo(() => {
    if (!props.renderHrefs) {
      return defaultRenderItem;
    }
    return (itemProps: PaginationRenderItemParams) => {
      const onClick = (e: SyntheticEvent) => {
        e.preventDefault();
        itemProps.onClick(e);
      };

      return (
        // @ts-ignore
        <PaginationItem {...itemProps} onClick={onClick} href={generateHref(itemProps.page - 1)} />
      );
    };
  }, [props.renderHrefs]);

  return (
    <DefaultPagination
      count={props.pageAmount}
      page={props.currentPage + 1}
      onChange={onChange}
      renderItem={renderItem}
      classes={props.classes}
    />
  );
};

export default Pagination;

const generateHref = (pageNumber: number) => {
  const params = new URLSearchParams(window.location.search);
  params.delete("page");
  params.append("page", pageNumber.toString());
  return window.location.pathname + "?" + params.toString();
};
